// extracted by mini-css-extract-plugin
module.exports = {"globalBannerContainer":"global-limit-banner_globalBannerContainer_209"};